import React, { Component } from "react";

import Warning from "../../../img/warning.svg"

export class ConfirmDelete extends Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  render() {
    return (
      <div className="wrapper">
        <img src={Warning} alt="Warning icon." style={{width: "108px", margin: "0 auto"}} />
        <h3>Are you sure you want to delete the last step from the list?</h3>
        <p>Any configuration you have added to this step will be lost.</p>
        <div className="button-row">
          <button className="secondary" onClick={() => this.props.setDialogDisplay({
            id: this.props.id,
            displayDialog: false
          })}>Cancel</button>
          <button className="primary" onClick={() => {
            if(this.props.sequence.length !== 0){
              this.props.removeSequence({
                id: this.props.id,
                index: this.props.sequence.length - 1
              })
            }
            // this.props.setInnerSection({
            //   id: this.props.id,
            //   innerSection: "THERMOCYCLER_TABLE"
            // });
            this.props.setDialogDisplay({
              id: this.props.id,
              displayDialog: false
            })
          }}>Delete</button>
        </div>
      </div>
    )
  }
}
